import { render, staticRenderFns } from "./AdvanceLoanEmptyState.vue?vue&type=template&id=fa6f1d22"
import script from "./AdvanceLoanEmptyState.vue?vue&type=script&lang=js"
export * from "./AdvanceLoanEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports